import useDfpSlot from "../../hooks/useDfpSlot";

const LoadHomeSideGoogleAds = () => {
    useDfpSlot([{
        path: "/22240682100/ROS_Footer1_300x250",
        size: [300, 250],
        id: "div-gpt-ad-1628625252827-0",
      },{
        path: "/22240682100/ROS_Footer2_300x250",
        size: [300, 250],
        id: "div-gpt-ad-1628625323242-0",
      },{
        path: "/22240682100/ROS_Footer3_300x250",
        size: [300, 250],
        id: "div-gpt-ad-1628625359907-0",
      },{
        path: "/22240682100/ROS_Footer4_300x250",
        size: [300, 250],
        id: "div-gpt-ad-1628625430383-0",
      },{
        path: "/22240682100/ROS_right_rail1_300x250",
        size: [300, 250],
        id: "div-gpt-ad-1628625083968-0",
      },{
        path: "/22240682100/ROS_right_rail2_300x250",
        size: [300, 250],
        id: "div-gpt-ad-1628625213078-0",
      }]);

    return(<></>)
}

export default LoadHomeSideGoogleAds;